import React from "react";
import ReactDOM from "react-dom";
import Navbar from "./components/Navbar/Navbar.jsx";
import Routes from "./routes/Routes.js";
import Footer from "./components/Footer/Footer.jsx";
import "./index.css";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";

const App = () => {
  let history = useHistory();

  function handleClick() {
    history.push("/admin");
  }
  return (
    <div className="appContainer">
      <Navbar />
      <Routes />
      <Footer />

    </div>
  );
};

export default App;
